var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { mapGetters } from "vuex";
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
import EntrustDeliverService from '../../api/EntrustDeliverService';
import CommonService from "../../api/CommonService";
import PrintConfigService from "../../api/PrintConfigService";
import { UrlHelper } from "../../helper/UrlWrapper";
import { billDefaultDate } from "../../helper/defaultDate";
import AreaShop from "@/components/AreaShop";
import ArticleList from "../../components/alert/ArticleList.vue";
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import sourceCodePrintList from '../sourceCodePrint/list.vue';
import MulUploadLicese from "../deliver/component/MulUploadLicese.vue";
import PrintSort from '../deliver/PrintSort.vue';
import BatchEditDialog from './component/BatchEditDialog.vue';
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        if (item.organ_id && !item.depot_id) {
            item.depot_id = "organ_id_" + item.organ_id;
            item.depot_name = item.organ_name;
        }
    });
}
var selectOrderIds = [];
export var EOrderType;
(function (EOrderType) {
    EOrderType[EOrderType["ORDER"] = 0] = "ORDER";
    EOrderType[EOrderType["NO_ORDER"] = 1] = "NO_ORDER";
    EOrderType[EOrderType["RETAIL"] = 2] = "RETAIL";
})(EOrderType || (EOrderType = {}));
var DeliverHeader = (function (_super) {
    __extends(DeliverHeader, _super);
    function DeliverHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sourceCodeBtnShow = false;
        _this.formData = {};
        _this.placeHolder = {
            1: '请输入送货单号',
            2: '请输入货品名称',
            3: '请输入分拣单',
            4: '请输入客户订货单',
            5: '请输入客户入库单',
            11: '请输入门店名称',
        };
        _this.businessList = [];
        _this.choiceDate = '';
        _this.EOrderType = EOrderType;
        _this.type = 'entrust';
        _this.isMoreSearch = false;
        _this.uploadLiceseShow = false;
        _this.orderStatusList = [];
        _this.outStoreList = [];
        _this.statusList = [{
                id: -1,
                name: '全部状态'
            }, {
                id: 0,
                name: '待审核'
            }, {
                id: 1,
                name: '已审核'
            }, {
                id: 2,
                name: '已完成'
            }, {
                id: 6,
                name: '已废弃'
            }];
        _this.timeType = [
            {
                label: "制单时间",
                value: "1"
            },
            {
                label: "审核时间",
                value: "2"
            },
            {
                label: "送货时间",
                value: "4"
            },
            {
                label: "预计到货日期",
                value: "5"
            }
        ];
        _this.is_split = null;
        _this.printModalVisbile = false;
        _this.openUrl = '';
        _this.is_Detail = 1;
        _this.export_dimension = 1;
        _this.exportModalVisbile = false;
        _this.logisticsOptions = [];
        _this.selectedLogistics = [];
        return _this;
    }
    DeliverHeader.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    DeliverHeader.prototype.created = function () {
        this.service = EntrustDeliverService.getInstance();
        this.commonService = CommonService.getInstance();
        this.printConfigService = PrintConfigService.getInstance();
    };
    DeliverHeader.prototype.mounted = function () {
        this.areaShopComp = this.$refs.areaShopRef;
        this.initData();
        this.getClient();
        this.search();
    };
    DeliverHeader.prototype.areAllValuesEqual = function (array, key) {
        if (array.length === 0) {
            return true;
        }
        var firstValue = array[0][key];
        for (var i = 1; i < array.length; i++) {
            if (array[i][key] !== firstValue) {
                return false;
            }
        }
        return true;
    };
    DeliverHeader.prototype.toExport = function (doExport) {
        var _this = this;
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; }) || [];
        var url = "supplierclientapi/entrust_delivery_order/export_order_list?order_ids=" + orderIds.join(",");
        url = UrlHelper.addParam(url, "token", this.user.token);
        url = UrlHelper.addParam(url, "type", this.is_Detail);
        url = UrlHelper.addParam(url, "export_dimension", this.export_dimension);
        this.formData.delivery_order_status = Array.isArray(this.formData.delivery_order_status) ? this.formData.delivery_order_status.join(",") : this.formData.delivery_order_status;
        var filter = {
            s_time: typeof (this.formData.s_time) == "object" ? this.formData.s_time.format("yyyy-MM-dd") : this.formData.s_time,
            e_time: typeof (this.formData.e_time) == "object" ? this.formData.e_time.format("yyyy-MM-dd") : this.formData.e_time,
            business_id: this.formData.business,
            keyword_type: this.formData.searchType,
            keyword: this.formData.text,
            shop_id: this.formData.lsid,
            area_ids: this.formData.aid,
            order_type: this.formData.order_type || -1,
            delivery_order_status: this.formData.delivery_order_status,
            out_depot_id: this.formData.out_depot_id.length ? this.formData.out_depot_id.join(',') : -1,
            time_type: this.formData.time_type,
            logistics_name: this.selectedLogistics.join(','),
        };
        for (var key in filter) {
            filter[key] = (filter[key] === undefined || filter[key] === null) ? '' : filter[key];
            url = UrlHelper.addParam(url, key, filter[key]);
        }
        if (!doExport && !this.areAllValuesEqual(this.selectedRows, 'business_id')) {
            this.exportModalVisbile = true;
            return false;
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        this.exportModalVisbile = false;
        window._czc.push(["_trackEvent", '委托送货单导出', '委托送货单导出']);
    };
    DeliverHeader.prototype.batchExport = function () {
        this.exportModalVisbile = true;
    };
    DeliverHeader.prototype.initData = function () {
        this.formData = {
            searchType: '1',
            text: '',
            business: '',
            s_time: billDefaultDate().Start,
            e_time: billDefaultDate().End,
            delivery_order_status: -1,
            order_type: '',
            out_depot_id: [],
            time_type: '1',
            logistics_name: ''
        };
        this.areaShopComp.resetData();
        this.getOrderStatusList();
        this.getOrganDepot();
        this.selectedLogistics = [];
    };
    DeliverHeader.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    DeliverHeader.prototype.uploadLicese = function () {
        this.uploadLiceseShow = true;
    };
    DeliverHeader.prototype.cancelDio = function (status) {
        this.uploadLiceseShow = status;
    };
    DeliverHeader.prototype.getOrganDepot = function () {
        var _this = this;
        var params = { is_init: 1 };
        this.commonService.getOrganDepot(params).then(function (res) {
            var data = res.data.data;
            tidyDepotList(data);
            _this.outStoreList = data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    DeliverHeader.prototype.getOrderStatusList = function () {
        var _this = this;
        this.commonService.getOrderStatusList().then(function (res) {
            if (res.data.success) {
                _this.orderStatusList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    DeliverHeader.prototype.audit = function () {
        var _this = this;
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        var auditMessage = "审核后将不可修改，是否继续？";
        if (this.selectedRows.length > 1) {
            auditMessage = "当前勾选" + this.selectedRows.length + "条单据，确定审核吗？";
        }
        this.$confirm(auditMessage).then(function () {
            var bindAuditAjax = function (params) {
                var loadingInstance = Loading.service({ fullscreen: true });
                _this.service.setAudit(params).then(function (res) {
                    loadingInstance.close();
                    if (res.data.code === 54) {
                        var instance_1 = _this.$dialog(ArtMsglist, {
                            data: {
                                msgData: res.data.data,
                            },
                        }, {
                            title: '提示',
                            width: 450,
                            height: 350,
                        }).instance;
                        instance_1.$on('artMsglist:ok', function (data) {
                            var confirm = res.data.data[0].confirm;
                            bindAuditAjax(__assign({}, params, { confirm: confirm }));
                        });
                        return;
                    }
                    if (res.data.code === 77) {
                        var instance_2 = _this.$dialog(ArtMsglist, {
                            data: {
                                msgData: res.data.data
                            },
                        }, {
                            title: '提示',
                            width: 450,
                            height: 350,
                        }).instance;
                        return;
                    }
                    if (res.data.code === 67) {
                        var text = res.data.msg.split('？');
                        var confirmText = [text[0] + '？', text[1]];
                        var newDatas = [];
                        var h = _this.$createElement;
                        for (var i in confirmText) {
                            newDatas.push(h('p', null, confirmText[i]));
                        }
                        _this.$confirm('提示', {
                            title: '提示',
                            message: h('div', null, newDatas),
                            confirmButtonText: "是",
                            cancelButtonText: "否",
                            type: "success",
                            showClose: false,
                        }).then(function (res) {
                            if (res) {
                                bindAuditAjax(__assign({}, params, { split_confirm: 1 }));
                            }
                        }).catch(function (action) {
                            if (action === "cancel") {
                                bindAuditAjax(__assign({}, params, { split_confirm: 0 }));
                            }
                        });
                        return;
                    }
                    if (res.data.code == 0) {
                        var data = res.data.data;
                        _this.$message.success("审核成功");
                        _this.$emit('search', _this.formData);
                        return;
                    }
                    if (res.data.code == 47) {
                        var instance_3 = _this.$dialog(ArtMsglist, {
                            data: {
                                msgData: res.data.data,
                            }
                        }, {
                            title: "提示",
                            width: 450,
                            height: 350
                        }).instance;
                        return;
                    }
                    if (res.data.code == 17) {
                        var instance_4 = _this.$dialog(ArtMsglist, {
                            data: {
                                msgData: res.data.data,
                                txtColor: "#FF2605"
                            },
                        }, {
                            title: '提示',
                            width: 450,
                            height: 350,
                        }).instance;
                        instance_4.$on('artMsglist:ok', function (data) {
                            bindAuditAjax(__assign({}, params, { stock_confirm: 1 }));
                        });
                        return;
                    }
                    if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        _this.$emit('search', _this.formData);
                        return;
                    }
                    var instance = _this.$dialog(ArticleList, {
                        data: {
                            resData: res.data,
                            modelType: 'deliver',
                            sureButtonText: "知道了"
                        }
                    }, {
                        title: "提示",
                        width: 450,
                        height: 350,
                        closeBtn: false,
                    }).instance;
                    instance.$on("addClient:ok", function (data) {
                        _this.$emit('search', _this.formData);
                    });
                }).catch(function (err) {
                    loadingInstance.close();
                    _this.$message.error(err.msg || err.message);
                });
            };
            bindAuditAjax({
                order_ids: orderIds.join(',')
            });
        }, function (err) { });
    };
    DeliverHeader.prototype.syncLicese = function () {
        var _this = this;
        if (!this.selectedRows.length) {
            this.$message.error("请选择委托送货单");
            return;
        }
        var orderIds = this.selectedRows.map(function (v) { return v.order_id; });
        var params = {
            order_ids: orderIds.join(',')
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.documentManualSync(params).then(function (res) {
            loadingInstance.close();
            if (res.data.success) {
                _this.$message.success(res.data.msg || "证照同步成功");
                _this.$emit('search', _this.formData);
                window._czc.push(["_trackEvent", '委托送货单', '证照同步']);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    DeliverHeader.prototype.discard = function () {
        var _this = this;
        if (!this.selectedRows || !this.selectedRows.length) {
            this.$message.warning("请选择单据");
            return;
        }
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        this.$confirm("请确认是否废弃选中的单据？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.setCancel({
                order_ids: orderIds.join(",")
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                }
                _this.$emit('search', _this.formData);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    DeliverHeader.prototype.getClient = function () {
        var _this = this;
        this.commonService.getClient().then(function (res) {
            if (res.data.success) {
                _this.businessList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    DeliverHeader.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.printData();
                break;
            case 2:
                this.exportData();
                break;
            case 3:
                this.discard();
                break;
            case 4:
                this.toExport();
                break;
            case 5:
                this.PDFfile();
                break;
            case 6:
                this.printSortingTag();
                break;
            case 7:
                this.exportListData();
                break;
        }
    };
    DeliverHeader.prototype.printSortingTag = function () {
        var _this = this;
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        window._czc.push(["_trackEvent", '委托送货单打印', '委托送货单打印']);
        var loadingInstance = Loading.service({ fullscreen: true });
        var businessIds = this.selectedRows.map(function (item) { return item.business_id; });
        var supplierTobusinessIds = this.selectedRows.map(function (item) { return item.supplier_to_business_id; });
        businessIds = _.uniq(businessIds);
        var params = {
            template_type: 21,
            business_id: businessIds.join(','),
            supplier_to_business_ids: supplierTobusinessIds.join(','),
        };
        this.printConfigService.printVerify(params).then(function (res) {
            loadingInstance.close();
            _this.addTab({
                component: PrintSort,
                title: '分拣标签打印',
                showExist: true,
                name: 'print_sort_entrusted',
                cprops: {
                    orderIds: orderIds.join(","),
                    type: 2
                },
                callback: function (result) {
                    if (result && result.comp && result.comp.getList) {
                        result.comp.orderIds = orderIds.join(",");
                        result.comp.getList();
                    }
                }
            });
        }, function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    DeliverHeader.prototype.printData = function () {
        var _this = this;
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        selectOrderIds = orderIds;
        var loadingInstance = Loading.service({ fullscreen: true });
        var businessIds = this.selectedRows.map(function (item) { return item.business_id; });
        var supplierTobusinessIds = this.selectedRows.map(function (item) { return item.supplier_to_business_id; });
        var logisticsTypes = this.selectedRows.map(function (item) { return item.logistics_type; });
        businessIds = _.uniq(businessIds);
        logisticsTypes = _.uniq(logisticsTypes);
        var params = {
            template_type: 8,
            business_id: businessIds.join(','),
            supplier_to_business_ids: supplierTobusinessIds.join(','),
        };
        this.printConfigService.printVerify(params).then(function (res) {
            loadingInstance.close();
            var printParams = {
                order_id: orderIds.join(","),
                is_split: 0,
                is_confirm: 0,
                logistics_type: logisticsTypes.join(','),
                business_id: businessIds.join(','),
                supplier_to_business_ids: supplierTobusinessIds.join(','),
                template_type: 8,
            };
            console.log(1111, printParams);
            _this.service.getDeliveryOrderPrintDetail(printParams).then(function (res) {
                if (res.data.code === 1100) {
                    _this.is_split = 1;
                    _this.printModalVisbile = true;
                }
                else {
                    _this.toPrintPage();
                }
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    DeliverHeader.prototype.toPrintPage = function () {
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "entrustDeliver");
        url = UrlHelper.addParam(url, 'order_id', selectOrderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        url = UrlHelper.addParam(url, 'is_split', this.is_split || '');
        url = UrlHelper.addParam(url, 'is_confirm', 1);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '委托送货单打印', '委托送货单打印']);
    };
    DeliverHeader.prototype.PDFfile = function () {
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; }) || [];
        if (orderIds.length == 0) {
            this.$message.error("请选择一个送货单");
            return;
        }
        ;
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "entrustDeliver");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'is_download', 1);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '委托送货单pdf下载', '委托送货单pdf下载']);
    };
    DeliverHeader.prototype.exportData = function () {
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; }) || [];
        if (orderIds.length != 1) {
            this.$message.error("请选择一个委托送货单");
            return;
        }
        ;
        var url = "supplierclientapi/entrust_delivery_order/export_order?order_id=" + orderIds.join(",");
        url = UrlHelper.addParam(url, "token", this.user.token);
        location.href = url;
        window._czc.push(["_trackEvent", '委托送货单导出', '委托送货单导出']);
    };
    DeliverHeader.prototype.exportListData = function () {
        var _this = this;
        var orderIds = this.$parent.getSelectIds();
        var url = "supplierclientapi/entrust_delivery_order/export_list_order?order_ids=" + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = this.$parent.getFormFilter();
        for (var key in filter) {
            filter[key] = (filter[key] === undefined || filter[key] === null) ? '' : filter[key];
            url = UrlHelper.addParam(url, key, filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(["_trackEvent", '导出委托送货单列表单据', '导出委托送货单列表单据']);
    };
    DeliverHeader.prototype.resetFormData = function () {
        if (this.formData.order_type != this.EOrderType.RETAIL) {
            var areaShopFormData = this.$refs.areaShopRef.getFormData();
            this.formData.aid = areaShopFormData.area_ids;
            this.formData.lsid = areaShopFormData.shop_id;
        }
        else {
            this.formData.aid = '';
            this.formData.lsid = '';
        }
    };
    DeliverHeader.prototype.search = function () {
        if (this.formData.delivery_order_status == 0 || this.formData.delivery_order_status == 1) {
            this.sourceCodeBtnShow = true;
        }
        else {
            this.sourceCodeBtnShow = false;
        }
        this.resetFormData();
        this.formData.logistics_name = this.selectedLogistics.join(',');
        this.$emit('search', this.formData);
    };
    DeliverHeader.prototype.moreSearchComShow = function () {
        this.areaShopComp.getArea();
        this.isMoreSearch = true;
        this.getLogisticsOptions();
    };
    DeliverHeader.prototype.moreSearchComHide = function () {
        this.isMoreSearch = false;
    };
    DeliverHeader.prototype.closeTab = function () {
        var closeBtnArr = $(".navTabsCloseBtn").prev();
        for (var i = 0; i < closeBtnArr.length; i++) {
            if ($(closeBtnArr[i])[0].innerText == "溯源码打印") {
                console.log($(closeBtnArr[i]).next());
                $(closeBtnArr[i]).next().click();
            }
        }
    };
    DeliverHeader.prototype.sourceCodePrint = function () {
        this.closeTab();
        var orderIds = this.selectedRows.map(function (item) { return item.order_id; });
        var orderSources = this.selectedRows.map(function (item) { return item.from_system_name; });
        var orderCustomers = this.selectedRows.map(function (item) { return item.customer; });
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        if (orderIds.length > 20) {
            this.$message.error("最多选择20条订单！");
            return;
        }
        var sourceTemp = orderSources[0], sourceFlag = false, customerTemp = orderCustomers[0], customerFlag = false;
        orderSources.forEach(function (item) {
            if (item !== sourceTemp) {
                sourceFlag = true;
            }
        });
        orderCustomers.forEach(function (item) {
            if (item !== customerTemp) {
                customerFlag = true;
            }
        });
        if (sourceFlag) {
            this.$message.error("请选择单据来源是供应链客户且同一客户的送货单!");
            return;
        }
        if (customerFlag) {
            this.$message.error("请选择单据来源是供应链客户且同一客户的送货单!");
            return;
        }
        sessionStorage.setItem("sourceCodeType", "entrust");
        this.addTab({
            component: sourceCodePrintList,
            title: '溯源码打印',
            showExist: true,
            name: 'source_list',
            cprops: {
                orderIds: orderIds.join(","),
                orderSources: sourceTemp || "",
                orderCustomers: customerTemp,
                isDelivery: true,
            },
        });
    };
    DeliverHeader.prototype.handleBatchEdit = function () {
        if (!this.selectedRows.length) {
            this.$message.warning('请选择需要修改的单据');
            return;
        }
        var invalidRows = this.selectedRows.filter(function (row) { return row.order_status_name !== '待审核'; });
        if (invalidRows.length) {
            this.$message.warning('请勾选待审核的单据');
            return;
        }
        this.$refs.batchEditDialog.show(this.selectedRows);
    };
    DeliverHeader.prototype.handleBatchEditSuccess = function () {
        this.$emit('search', this.formData);
    };
    DeliverHeader.prototype.getLogisticsOptions = function () {
        var _this = this;
        this.commonService.getLogisticsAllOptions().then(function (res) {
            if (res.data.success) {
                _this.logisticsOptions = res.data.data || [];
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    __decorate([
        Prop()
    ], DeliverHeader.prototype, "selectedRows", void 0);
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], DeliverHeader.prototype, "rows", void 0);
    DeliverHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user",
                "ediStatus": "ediStatus",
                openedCodeData: 'openedCodeData'
            })),
            components: {
                "areaShop": AreaShop,
                "mulUploadLicese": MulUploadLicese,
                BatchEditDialog: BatchEditDialog
            }
        })
    ], DeliverHeader);
    return DeliverHeader;
}(Vue));
export default DeliverHeader;
